import { ProcedureCode } from 'src/contracts/procedureCode';
import { DiagnosisCode } from 'src/contracts/diagnosisCode';
import { GrouperData } from 'src/contracts/grouperData';
import { PatientData } from 'src/contracts/patientData';
import {
  DiagnosisResultDto,
  GetGrouperDataResponse,
  GrouperPatientInfo,
  ProcedureResultDto
} from 'src/contracts/getGrouperDataResponse';
import { isEmpty } from 'src/common/arrayUtil';

export class GrouperServiceConverter {

  public static convertGrouperData(response: GetGrouperDataResponse): GrouperData | undefined {
    if (!response) {
      console.log('Undefined response');
      return undefined;
    }

    return {
      patient: this.getPatient(response.patient),
      diagnosisCodes: this.getDiagnosisCodes(response.diagnoses),
      procedureCodes: this.getProcedureCodes(response.procedures)
    };
  }

  private static getPatient(patientData: GrouperPatientInfo): PatientData {
    if (!patientData) {
      throw new Error('Patient data not found');
    }

    return {
      name: patientData.patient_full_name,
      dischargeDate: patientData.discharge_date || 'none',
      sex: patientData.sex,
      codingSystem: patientData.coding_system
    }
  }

  private static getProcedureCodes(procedures: ProcedureResultDto[]): ProcedureCode[] {
    if (isEmpty(procedures)) {
      return [];
    }

    return procedures.map((procedure: ProcedureResultDto) => {
      return <ProcedureCode>{
        id: procedure.position,
        code: procedure.code,
        action: undefined,
        description: procedure.description,
        slot: [],
        impact: []
      }
    })
  }

  private static getDiagnosisCodes(diagnoses: DiagnosisResultDto[]): DiagnosisCode[] {
    if (isEmpty(diagnoses)) {
      return [];
    }

    return diagnoses.map((diagnosis: DiagnosisResultDto) => {
      return <DiagnosisCode>{
        id: diagnosis.position,
        code: diagnosis.code,
        action: undefined,
        description: diagnosis.description,
        pdx: ['pdx'],
        drgModifier: ['CC'],
        poa: diagnosis.poa?.trim(),
        quality: ['HAC', 'PSI'],
        risk: diagnosis.flags,
      }
    })
  }
}
